module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Screens/translator/translator.component.css
// module id = ./src/app/Screens/translator/translator.component.css
// module chunks = main